import { transient } from "aurelia-framework";
import { BaseRuleConfigPlugin } from "../plugins/base-rule-config-plugin";

@transient()
export class WindwardPrefetch extends BaseRuleConfigPlugin {

}